import type { ToolsTranslations } from "../../types/tools";

export const tools: ToolsTranslations = {
  title: "Tööriistad",
  subtitle: "Franklini sisemised tööriistad",
  drawingCompare: {
    navLabel: "Joonised",
    description: "Vaata DWG jooniseid originaalvärvides ja võrdle versioone muudatuste nägemiseks.",
    selectProject: "Projekt",
    stopCompare: "Lõpeta võrdlemine",
    applySelection: "Rakenda",
    compareDifferences: "Võrdle erinevusi",
    selectTwoDrawings: "Vali võrdlemiseks täpselt kaks joonist",
    drawingsCountSuffix: "joonist",
    compareOlder: "Vanem",
    compareNewer: "Uuem",
    compareSwap: "Vaheta vanem / uuem",
    showVersions: "Näita vanemaid versioone",
    hideVersions: "Peida vanemad versioonid",
    noProjects: "Projekte pole saadaval.",
    noDrawings: "Selles projektis pole veel DWG-jooniseid.",
    loadingDrawings: "Jooniste laadimine…",
    drawingsLoadFailed: "Jooniseid ei õnnestunud laadida – proovi uuesti",
    chooseDrawing: "Vali joonis…",
    browseAllDrawings: "Sirvi kõiki {count} DWG faile",
    sectionSelected: "Valitud",
    sectionRecent: "Hiljutised",
    sectionLatestUploads: "Viimati lisatud",
    browseDrawingsTitle: "Sirvi jooniseid",
    comparing: "Võrdlen…",
    preparingDrawing: "Valmistan joonist ette…",
    samePairError:
      "Mõlemal pool on sama joonise versioon — vali võrdluseks kaks erinevat versiooni.",
    modeOverlay: "Ülekate",
    modeSide: "Kõrvuti",
    modeHighlight: "Ainult muutused",
    modeSwipe: "Lohista",
    modeBlink: "Vilkumine",
    toolRuler: "Joonlaud",
    toolArea: "Pindala",
    toolCoordinate: "Koordinaat",
    createIssue: "Loo ülesanne",
    createIssueHint: "Klõpsa joonisel kohta, kuhu ülesanne luua — Esc tühistab",
    showIssues: "Näita ülesandeid",
    hideIssues: "Peida ülesanded",
    issueMarkerLabel: "Ava ülesanne nr {n}",
    issueLoadFailed: "Ülesande laadimine ebaõnnestus.",
    fit: "Mahuta",
    zoomIn: "Suumi sisse",
    zoomOut: "Suumi välja",
    downloadScreenshot: "Laadi ekraanipilt alla",
    showControls: "Näita juhtnuppe",
    hideControls: "Peida juhtnupud",
    layers: "Kihid",
    layersAll: "Kõik",
    layersChanged: "Ainult muutunud",
    legendAdded: "Lisatud",
    legendRemoved: "Eemaldatud",
    legendUnchanged: "Muutmata",
    legendRedrawn: "Uuesti joonistatud rida",
    legendRedrawnHint:
      "Eemaldatud või lisatud objektid, mille jooned on teises versioonis endiselt samas kohas, samas värvis, joonepaksuses ja -stiilis. Joonisel need midagi ei muuda, seega ülaltoodud arvestusse neid ei võeta.",
    legendRedrawnSplit:
      "{a} vanemas versioonis, {b} uuemas. Üks objekt võib olla uuesti joonistatud mitmena, seega pooled ei pea kattuma ja kokku loetakse ridu, mitte objekte.",
    legendRedrawnAtLeast:
      "See võrdlus esitas tühistatud read ainult ühe versiooni kohta, seega tühistati vähemalt nii palju ridu — teise versiooni arv pole teada.",
    bgDark: "Tume",
    bgLight: "Hele",
    exportPdf: "Ekspordi PDF",
    exportTitle: "PDF-i eksport",
    exportAccept: "Laadi PDF alla",
    exportCancel: "Tühista",
    exportDrawWindow: "Joonista aken",
    exportDrawAgain: "Joonista uuesti",
    exportWholeDrawing: "Kogu joonis",
    exportPickHint: "Klõpsa akna kaks vastasnurka — Esc tühistab",
    viewerEngineFailed:
      "Joonisevaaturi mootorit ei õnnestunud laadida. Värskenda lehte ja proovi uuesti.",
    placeholder: "Vali joonis, et seda vaadata — vali teine, et neid võrrelda.",
    invalidIds: "Joonise vaatur vajab 1 või 2 dokumendi ID-d.",
    seedNotFound: "Soovitud joonist ei leitud.",
    loading: "Joonise laadimine…",
    accuracyNotice:
      "Ainult visuaalne eelvaade. Mõned elemendid võivad originaalist erineda. Üksikasjalikuks ülevaatuseks ja kontrolliks kasuta lähte-DWG-faili.",
  },
};
